/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AxiosError } from 'axios';

import Constants from '@/Constants';
import { GenericApiResponse } from '@/services/api';

export enum ErrorCode {
  InvalidCredentials = 1,
  InvalidAdminCode = 2,
  InvalidProgramCode = 3,
  IncorrectPassword = 4,
  InvalidPassword = 5,
  PasswordExists = 6,
  AccessTokenExpired = 7,
  InvalidAccessToken = 8,
  AccessTokenRequire = 9,
  InvalidStudentId = 10,
  PasswordLinkExpired = 11,
  InvalidStudentCenter = 12,
  InvalidAdminCenter = 13,
  InvalidAdminId = 14,
  InvalidRefreshToken = 15,
  InvalidStartCode = 21,
  InvalidAbortCode = 28,
  InvalidStudentCode = 16,
  AssessmentNotAvailable = 42,
  AuthHeaderRequired = 17,
  InvalidAssessmentId = 18,
  AssessmentNotLive = 19,
  AssessmentAlreadyTaken = 20,
  TestAlreadyGoingOn = 22,
  InvalidAttemptId = 24,
  InvalidInvigilatorId = 25,
  InvalidProgramId = 26,
  InvalidSubjectId = 27,
  AttemptLimitExceeded = 29,
  InvalidQuestionId = 30,
  SubjectNotFound = 31,
  LevelNotFound = 32,
  MissionNotFound = 33,
  StagesNotFound = 34,
  ModuleNotFound = 35,
  InvalidMissionId = 36,
  InvalidStageId = 37,
  InvalidModuleId = 38,
  StageLocked = 39,
  IncompleteEngagementStrategy = 40,
  InvalidLevelId = 41,
  QuestionNotFound = 43,
  PracticeContentNotFound = 44,
  StageCompleted = 45,
  MissionLocked = 46,
  IncompleteMission = 47,
  AdminAndProgramCodeMismatch = 49,
  InvalidAccessCode = 65,
}

interface ErrorData {
  code?: number;
  message?: string;
}

export const getErrorMessageFromCode = (code: ErrorCode, t: (key: string) => string): string => {
  switch (code) {
    case ErrorCode.InvalidAdminCode: {
      return t('apiError:invalidAdminCode');
    }
    case ErrorCode.InvalidProgramCode: {
      return t('apiError:invalidProgramCode');
    }
    case ErrorCode.IncorrectPassword: {
      return t('apiError:incorrectPassword');
    }
    case ErrorCode.InvalidPassword: {
      return t('apiError:incorrectPassword');
    }
    case ErrorCode.PasswordExists: {
      return t('apiError:passwordAlreadyExist');
    }
    case ErrorCode.InvalidStartCode: {
      return t('apiError:invalidCodeTryAgain');
    }
    case ErrorCode.InvalidAbortCode: {
      return t('apiError:invalidCodeTryAgain');
    }
    case ErrorCode.InvalidStudentCode: {
      return t('apiError:invalidStudentCode');
    }
    case ErrorCode.AdminAndProgramCodeMismatch: {
      return t('apiError:programAndAdminDoNotMatch');
    }
    case ErrorCode.InvalidAccessCode: {
      return 'The access code is invalid or has expired. Please try again!';
    }
    default: {
      return t('translation:errorOccured');
    }
  }
};

export const getErrorInfoFromCode = (data: ErrorData, url?: string) => {
  if (!data.code && !data.message) {
    return {
      key: 'somethingWentWrong',
    };
  }
  if (!data.code && data.message) {
    return {
      message: data.message,
    };
  }

  const result: { key?: string; message?: string } = {};
  switch (data.code) {
    case ErrorCode.InvalidCredentials: {
      switch (url) {
        case Constants.GET_RESET_PASSWORD_TOKEN_URL: {
          result.key = 'invalidResetPasswordCode';
          break;
        }
        default: {
          if (data.message) {
            result.message = data.message;
          } else {
            result.key = 'invalidCredentials';
          }
          break;
        }
      }
      break;
    }
    case ErrorCode.InvalidAdminCode: {
      result.key = 'invalidAdminCode';
      break;
    }
    case ErrorCode.InvalidProgramCode: {
      result.key = 'invalidProgramCode';
      break;
    }
    case ErrorCode.IncorrectPassword: {
      result.key = 'incorrectPassword';
      break;
    }
    case ErrorCode.InvalidPassword: {
      result.key = 'invalidPassword';
      break;
    }
    case ErrorCode.PasswordExists: {
      result.key = 'passwordAlreadyExist';
      break;
    }
    case ErrorCode.InvalidStartCode: {
      result.key = 'incorrectTestCode';
      break;
    }
    case ErrorCode.InvalidAbortCode: {
      result.key = 'incorrectAbortCode';
      break;
    }
    // case ErrorCode.AccessTokenExpired: {
    //   result.key = 'accessTokenExpired';
    //   break;
    // }
    // case ErrorCode.InvalidAccessToken: {
    //   result.key = 'invalidAccessToken';
    //   break;
    // }
    // case ErrorCode.AccessTokenRequire: {
    //   result.key = 'accessTokenRequire';
    //   break;
    // }
    // case ErrorCode.InvalidStudentId: {
    //   result.key = 'invalidStudentId';
    //   break;
    // }
    // case ErrorCode.PasswordLinkExpired: {
    //   result.key = 'passwordLinkExpired';
    //   break;
    // }
    // case ErrorCode.InvalidStudentCenter: {
    //   result.key = 'invalidStudentCenter';
    //   break;
    // }
    // case ErrorCode.InvalidAdminCenter: {
    //   result.key = 'invalidAdminCenter';
    //   break;
    // }
    // case ErrorCode.InvalidAdminId: {
    //   result.key = 'invalidAdminId';
    //   break;
    // }
    // case ErrorCode.InvalidRefreshToken: {
    //   result.key = 'invalidRefreshToken';
    //   break;
    // }
    case ErrorCode.InvalidStudentCode: {
      result.key = 'invalidStudentCode';
      break;
    }
    case ErrorCode.AuthHeaderRequired: {
      result.key = 'authHeaderRequired';
      break;
    }
    // case ErrorCode.InvalidAssessmentId: {
    //   result.key = 'invalidAssessmentId';
    //   break;
    // }
    // case ErrorCode.AssessmentNotLive: {
    //   result.key = 'assessmentNotLive';
    //   break;
    // }
    // case ErrorCode.AssessmentAlreadyTaken: {
    //   result.key = 'assessmentAlreadyTaken';
    //   break;
    // }
    // case ErrorCode.TestAlreadyGoingOn: {
    //   result.key = 'testAlreadyGoingOn';
    //   break;
    // }
    // case ErrorCode.InvalidAttemptId: {
    //   result.key = 'invalidAttemptId';
    //   break;
    // }
    // case ErrorCode.InvalidInvigilatorId: {
    //   result.key = 'invalidInvigilatorId';
    //   break;
    // }
    // case ErrorCode.InvalidProgramId: {
    //   result.key = 'invalidProgramId';
    //   break;
    // }
    // case ErrorCode.InvalidSubjectId: {
    //   result.key = 'invalidSubjectId';
    //   break;
    // }
    // case ErrorCode.AttemptLimitExceeded: {
    //   result.key = 'attemptLimitExceeded';
    //   break;
    // }
    // case ErrorCode.InvalidQuestionId: {
    //   result.key = 'invalidQuestionId';
    //   break;
    // }
    // case ErrorCode.SubjectNotFound: {
    //   result.key = 'subjectNotFound';
    //   break;
    // }
    // case ErrorCode.LevelNotFound: {
    //   result.key = 'levelNotFound';
    //   break;
    // }
    // case ErrorCode.MissionNotFound: {
    //   result.key = 'missionsNotFound';
    //   break;
    // }
    // case ErrorCode.StagesNotFound: {
    //   result.key = 'stagesNotFound';
    //   break;
    // }
    // case ErrorCode.ModuleNotFound: {
    //   result.key = 'moduleNotFound';
    //   break;
    // }
    // case ErrorCode.InvalidMissionId: {
    //   result.key = 'invalidMissionId';
    //   break;
    // }
    // case ErrorCode.InvalidStageId: {
    //   result.key = 'invalidStageId';
    //   break;
    // }
    // case ErrorCode.InvalidModuleId: {
    //   result.key = 'invalidModuleId';
    //   break;
    // }
    // case ErrorCode.StageLocked: {
    //   result.key = 'lockedStage';
    //   break;
    // }
    // case ErrorCode.IncompleteEngagementStrategy: {
    //   result.key = 'incompleteEngagementStrategy';
    //   break;
    // }
    // case ErrorCode.InvalidLevelId: {
    //   result.key = 'invalidLevelId';
    //   break;
    // }
    // case ErrorCode.AssessmentNotAvailable: {
    //   result.key = 'assessmentNotAvailable';
    //   break;
    // }
    // case ErrorCode.QuestionNotFound: {
    //   result.key = 'questionNotFound';
    //   break;
    // }
    // case ErrorCode.PracticeContentNotFound: {
    //   result.key = 'practiceContentNotFound';
    //   break;
    // }
    // case ErrorCode.StageCompleted: {
    //   result.key = 'stageCompleted';
    //   break;
    // }
    // case ErrorCode.MissionLocked: {
    //   result.key = 'missionLocked';
    //   break;
    // }
    // case ErrorCode.IncompleteMission: {
    //   result.key = 'incompleteMission';
    //   break;
    // }
    default: {
      if (data.message) {
        result.message = data.message;
      } else {
        result.key = 'unknownError';
      }
    }
  }
  return result;
};

export function getErrorMessage<T>(
  payload: GenericApiResponse<T> | AxiosError<GenericApiResponse<T>> | undefined,
  t: (key: string) => string,
): string {
  if (!payload) {
    return 'Something went wrong';
  }
  if (payload instanceof Error) {
    if (payload.response?.status) {
      switch (payload.response.status) {
        case 500: {
          return 'Internal Server Error. Please try again later.';
        }
        case 502: {
          return 'Bad Gateway. The server is down or unreachable.';
        }
        case 503: {
          return 'Service Unavailable. Please try again later.';
        }
        case 504: {
          return 'Gateway Timeout. The server took too long to respond.';
        }
        default: {
          return `Unexpected error occurred. Status: ${payload.response.status}`;
        }
      }
    }
    if (payload.code?.includes('ERR_NAME_NOT_RESOLVED')) {
      return 'Unable to resolve the server name. Please check your internet connection.';
    }
    if (payload.code?.includes('ERR_NETWORK')) {
      return 'No internet connection. Please check your network settings.';
    }
    return payload.message || 'Something went wrong.';
  }
  if (payload?.status && !payload.data.code && !payload.data.message) {
    switch (payload.status) {
      case 400: {
        return 'Bad Request. Please check the input and try again.';
      }
      case 401: {
        return 'Unauthorized. Please login and try again.';
      }
      case 403: {
        return 'Forbidden. You do not have permission to access this resource.';
      }
      case 404: {
        return 'Not Found. The requested resource could not be found.';
      }
      default: {
        return `Unexpected error occurred. Status: ${payload.status}`;
      }
    }
  }

  if (payload.data && typeof payload.data === 'object') {
    const errorInfo = getErrorInfoFromCode(payload.data, payload.config?.url);
    if (errorInfo.key) {
      return t(`apiError:${errorInfo.key}`);
    }
    return errorInfo.message || 'Some error occurred';
  }

  return 'Some unknown error occurred';
}
